import { render, staticRenderFns } from "./CreateMappingBanner.vue?vue&type=template&id=1cf9a7ec&scoped=true&"
import script from "./CreateMappingBanner.vue?vue&type=script&lang=js&"
export * from "./CreateMappingBanner.vue?vue&type=script&lang=js&"
import style1 from "./CreateMappingBanner.vue?vue&type=style&index=1&id=1cf9a7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf9a7ec",
  null
  
)

export default component.exports